module.exports = __webpack_public_path__ + "static/img/home_TitleLine.b20c0a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_TitleLine.png
// module id = il4j
// module chunks = 1 2